module.exports = __webpack_public_path__ + "img/banner.c29490c6.jpg";